import { render, staticRenderFns } from "./GenerateList.vue?vue&type=template&id=1b71570c"
import script from "./GenerateList.vue?vue&type=script&lang=js"
export * from "./GenerateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b71570c')) {
      api.createRecord('1b71570c', component.options)
    } else {
      api.reload('1b71570c', component.options)
    }
    module.hot.accept("./GenerateList.vue?vue&type=template&id=1b71570c", function () {
      api.rerender('1b71570c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/form/GenerateList.vue"
export default component.exports